import { render, staticRenderFns } from "./AdvanceList.vue?vue&type=template&id=670ec934&scoped=true"
import script from "./AdvanceList.vue?vue&type=script&lang=js"
export * from "./AdvanceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670ec934",
  null
  
)

export default component.exports